export const SET_CATEGORIES = 'COMMUNICATIONS/SET_CATEGORIES';
export const MARK_MESSAGE_AS_READ = 'COMMUNICATIONS/MARK_MESSAGE_AS_READ';
export const MARK_CATEGORY_AS_READ = 'COMMUNICATIONS/MARK_CATEGORY_AS_READ';
export const RESTORE_CATEGORY_UNREAD_COUNT = 'COMMUNICATIONS/RESTORE_CATEGORY_UNREAD_COUNT';
export const SET_TEASERS_LOADING = 'COMMUNICATIONS/SET_TEASERS_LOADING';
export const SET_CATEGORIES_LOADING = 'COMMUNICATIONS/SET_CATEGORIES_LOADING';
export const SET_MARK_AS_READ_LOADING = 'COMMUNICATIONS/SET_MARK_AS_READ_LOADING';
export const SET_UNREAD_TOTAL = 'COMMUNICATIONS/SET_UNREAD_TOTAL';
export const setCategories = (payload) => ({
    type: SET_CATEGORIES,
    payload
});
export const setUnreadTotal = (payload) => ({
    type: SET_UNREAD_TOTAL,
    payload
});
export const markMessageAsRead = (payload) => ({
    type: MARK_MESSAGE_AS_READ,
    payload
});
export const markCategoryAsRead = (payload) => ({
    type: MARK_CATEGORY_AS_READ,
    payload
});
export const restoreCategoryUnreadCount = (payload) => ({
    type: RESTORE_CATEGORY_UNREAD_COUNT,
    payload
});
export const setTeasersLoading = (payload) => ({
    type: SET_TEASERS_LOADING,
    payload
});
export const setCategoriesLoading = (payload) => ({
    type: SET_CATEGORIES_LOADING,
    payload
});
export const setMarkCategoryAsReadLoading = (payload) => ({
    type: SET_MARK_AS_READ_LOADING,
    payload
});
